import React from "react";

const RootCauseQA = ({ QA }) => {
  return (
    <div className="qa-section p-3 border rounded mb-3">
      <h5 className="mb-3">Root Cause Questions & Answers</h5>
      {QA.length > 0 ? (
        <ul className="list-group">
          {QA.map((item, index) => (
            <li key={index} className="list-group-item">
              <p className="mb-1">
                <strong>Q:</strong> {item.question}
              </p>
              <p className="mb-0">
                <strong>A:</strong> {item.answer || "No answer provided"}
              </p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-muted">No questions or answers available.</p>
      )}
    </div>
  );
};

export default RootCauseQA;
